import "./main.css"
import { toolsContext } from "../hooks/Context"
import { useContext } from "react"
import { MainBoxes } from "./mainboxes";
export function MainContent() {
  const toolsContextData = useContext(toolsContext);
  return (
    <>
      <div>
        {/* <div className="tags-area">
          <button className="tag-button"><i className="bi bi-calendar-check-fill pe-2"></i>Today</button>
          <button className="tag-button"><i className="bi bi-newspaper pe-2"></i>New</button>
          <button className="tag-button"><i className="bi bi-bookmark-fill pe-2"></i>Most Saved</button>
          <button className="tag-button"><i className="bi bi-check-circle-fill pe-2"></i>Most Used</button>
          <button className="tag-button"><i className="bi bi-browser-chrome pe-2"></i>Browser Ext.</button>
          <button className="tag-button"><i className="bi bi-google-play pe-2"></i>Apps</button>
          <button className="tag-button"><i className="bi bi-discord pe-2"></i>Discord</button>
          <button className="tag-button tag-social"><i className="bi bi-twitter pe-2"></i>@toolify</button>
        </div> */}

        <div className="grid-area-box py-4">
          <MainBoxes />
        </div>
      </div>

    </>

  )
}

// import "./main.css"
// import { toolsContext } from "../hooks/Context"
// import { useContext } from "react"
// import { MainBoxes } from "./mainboxes";

// export function MainContent() {
//   const toolsContextData = useContext(toolsContext);

//   return (
//     <>
//       <div className="main-area-box1">
//         <div className="tags-area">
//           <button className="tag-button"><i class="bi bi-calendar-check-fill pe-2"></i>Today</button>
//           <button className="tag-button"><i class="bi bi-newspaper pe-2"></i>New</button>
//           <button className="tag-button"><i class="bi bi-bookmark-fill pe-2"></i>Most Saved</button>
//           <button className="tag-button"><i class="bi bi-check-circle-fill pe-2"></i>Most Used</button>
//           <button className="tag-button bro-tag "><i class="bi bi-browser-chrome pe-2"></i> Browser Extension</button>
//           <button className="tag-button"><i class="bi bi-google-play pe-2"></i>Apps</button>
//           <button className="tag-button d-tag"><i class="bi bi-discord pe-2"></i>Discord Of AI</button>
//           <button className="tag-button tag-end"><i class="bi bi-twitter pe-2"></i>@toolify</button>
//         </div>

//         <div className="grid-area-box py-4">
//           {/* ❌ yeh galat tha: har tool ke liye MainBoxes */} */}
//           {/* {toolsContextData.map((tool) => (
//               <MainBoxes ... />
//           ))}

//           {/* ✅ Bas ek hi dafa render karo */}
//           <MainBoxes />
//         </div>
//       </div>
//     </>
//   );
// }
